import { CLIENT_STYLINGS } from './constants'

export const getBorderRadius = (props, scale = 'md') => {
  const baseRadius = CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_RADIUS * 16
  switch (scale) {
    case 'sm':
      return `${Math.max(0, baseRadius - 4)}px`
    case 'md':
      return `${Math.max(0, baseRadius - 2)}px`
    case 'lg':
      return `${Math.max(0, baseRadius)}px`
    case 'xl':
      return `${Math.max(0, baseRadius + 4)}px`
    default:
      return `${Math.max(0, baseRadius)}px`
  }
} 